__turbopack_context__.v({
  "className": "geist_7e573fc1-module__ELTdiq__className",
  "variable": "geist_7e573fc1-module__ELTdiq__variable",
});
